var UbpHome = (function () {


  /* ---------------------------------------------------------
  Module: SCRIPTS HOME PAGE: PROGETTI, FILTRI, MAPPA
  Added:
  --------------------------------------------------------- */

  var homeScripts = function () {

    /* ---------------------------------------------------------
		Module: Mostra Progetti dell'edizione richiesta
		Added:
		--------------------------------------------------------- */

		var edition = $('ul#edizioni-select li.selected').val();

    console.log('edition', edition);


		// . mostra tile con i progetti dell'edizione richiesta
		function ubp_show_contents(projects_data) {

      var outputgrid = '';
      var outputlist = '';
			var posts = projects_data.posts;
      var idEdizione = UbpEdizioni.idEdizione(edition);



      // loop dei post
			for(var i=0;i<posts.length;i++) {
        posts[i].tile_classes = posts[i].tile_classes.join(' ');
        posts[i].list_classes = posts[i].list_classes.join(' ');

        // ----------------------------------------------------------------
        // output PROGETTI
        if(posts[i].tipo_di_post == 'progetti'){
          outputgrid += LayoutGriglia.progetto(posts[i], idEdizione);
          outputlist += LayoutLista.eventoProgetto(posts[i], idEdizione);
        }

        // ----------------------------------------------------------------
        // output EVENTI - NOT IN HOME
        if (posts[i].tipo_di_post == 'eventi' && !$('body').hasClass('home')) {
          outputgrid += LayoutGriglia.evento(posts[i], idEdizione);
          outputlist += LayoutLista.eventoProgetto(posts[i], idEdizione);
        }

        // ----------------------------------------------------------------
        // output CONTRIBUTI
        if(posts[i].tipo_di_post == 'contributi'){
          outputgrid += LayoutGriglia.contributo(posts[i], idEdizione);
          outputlist += LayoutLista.contributo(posts[i], idEdizione);
        }
			}


      // -----------------------------------
      // Rigenero isotope

			var canvas_backup = $('#iso #grid_bck');

			$container.html('').
			append(canvas_backup).
			isotope('destroy').
			append(outputgrid).
			isotope({ //Isotope options, 'item' matches the class in the PHP
			  itemSelector : '.item',
				layoutMode : 'packery'
			});

      $('.iso-list').html('').
      // isotope('destroy').
      append(outputlist).
      isotope({ //Isotope options, 'item' matches the class in the PHP
			  itemSelector : '.iso-item',
				layoutMode : 'packery'
			});

      // -----------------------------------
      // Rigenero packery per riempire gli spazi

			if (pckry) { pckry.destroy(); }

			container = document.querySelector('.packery');
			if (container) {
				pckry = new Packery( container, {
					itemSelector: '.item',
					gutter: 0
				});

				pckry.reloadItems();
				pckry.layout();
			}

			// pckry.on( 'layoutComplete', drawSpaces );
			//hack, trigger another layout for first rendering
			// pckry.layout();

			return false;

		}


    /* ---------------------------------------------------------
		Module: Carica i dati dei progetti della edizione richiesta via AJAX
		Added:
		--------------------------------------------------------- */

		var projects_data = {};

		function ubp_loadprojectdata(){

			edition = $('ul#edizioni-select li.selected').val(); //es. 2019
			the_blog_id = UbpEdizioni.idEdizione(edition);

      console.log('edition: ' + edition);

      // -----------------------------------
      // Chiamata ajax

      $.ajax({
        url : rw_ajax_obj.ajax_url,
        type : 'post',
        data : {
          action : 'ubp_load_posts',
          // security : rw_ajax_obj.ajax_nonce,
          blog_id: the_blog_id,
          post_type : ['progetti','eventi','contributi'],
          order: 'id',
          _ajax_nonce: $('#filtri-globali').attr('data-n')
        },
        beforeSend: function() {
        },
        success : function( response ) {

          $('#edition-loader').remove();

  				json = $.parseJSON(response);
  				projects_data = json;

  				var filter_data = {
            titoloevento: json.titoloevento,
  					temi: json.temi,
  					promotori: json.promotori,
            luoghi: json.luoghi,
            parolechiave: json.parolechiave
  				};

          // Rimuove le classi dei siti precedenti e aggiunge quella del sito attivo
          $('body').removeClass (function (index, className) {
            return (className.match (/(^|\s)site-\S+/g) || []).join(' ');
          }).addClass('site-' + the_blog_id);

          //UPDATE DELLE TILES Edizioni
          // console.log(json);
          // console.log(json.ev_beta);
          // console.log(json.ev_gamma);
          // console.log(json.ev_delta);

          // in base al tipo di evento restituisce i dettagli
          function updateTilesEventi(tipoEv, tile, urlEv, imgEv){

            if(tipoEv){
              $(target + ' .titolo-tile').text(tipoEv['titolo']);
              $(target + ' .data-luogo .data').html(tipoEv['data']);
              $(target + ' .data-luogo .luogo-1').html(tipoEv['luogo1']);
              $(target + ' .data-luogo .luogo-2').html(tipoEv['luogo2']);
              $(target + ' .descrizione').html(tipoEv['luogo2']); // workaround descrizione LETTURE / PRESENTA
            }

            var target = '#menu-tiles .' + tile;
            $(target + ' .img-overlay').attr('href', urlEv);
            $(target + ' .img-overlay').attr('style', 'background-image:url(\''+ imgEv +'\');');

            // $(target + ' .urbox').removeClass('non-attiva');
            // GESTIONE TILES INATTIVE
            if($(target).hasClass('tile-a') || $(target).hasClass('tile-b')){
              var $enabler = $(target);
            } else {
              var $enabler = $(target).find('.urbox');
            }

            if($enabler.length){
              $enabler.removeClass('non-attiva');
              if(!tipoEv['titolo'].length){
                $enabler.addClass('non-attiva');
              }
            }

          }
          updateTilesEventi(json.ev_alfa, 'tile-2', json.ev_alfa_url, json.ev_alfa_img);
          updateTilesEventi(json.ev_beta, 'tile-3', json.ev_beta_url, json.ev_beta_img);
          updateTilesEventi(json.ev_gamma, 'tile-4', json.ev_gamma_url, json.ev_gamma_img);
          updateTilesEventi(json.ev_delta, 'tile-1', json.ev_delta_url, json.ev_delta_img);
          updateTilesEventi(json.ev_epsilon, 'tile-a', json.ev_epsilon_url, json.ev_epsilon_img);
          updateTilesEventi(json.ev_zeta, 'tile-b', json.ev_zeta_url, json.ev_zeta_img);

          // console.log(json.ev_gamma);
          // updateTilesEventi(json.ev_epsilon, 'tile-0', json.ev_epsilon_url);
          // updateTilesEventi(json.ev_zeta, 'tile-0', json.ev_zeta_url);


  				ubp_update_filters(filter_data);
          ubp_show_contents(projects_data);


  				if ($('#projects-map').hasClass('active')) {
            // var map; // senza questo da un errore in console
            // console.log('refresh mappa');
            LayoutMappa.mappa(projects_data);
          }

          // Ricarico la funzione Love per mettere i preferiti
          if (typeof RwAjaxLove != 'undefined') {
            RwAjaxLove.start();
          }

          $('#projects-map').addClass('firstinit');
  				return projects_data;

        },
        error: function( jqXHR, textStatus, errorThrown ){
          console.log( 'Errore: ' + textStatus, errorThrown );
        },
        complete: function( jqXHR, textStatus ){

          // Refresh lista - da raggruppare poi con griglia e mappa (vedi rungallery)
          // ISOTOPE FITROWS
          var $gridFit = $('.iso-list').isotope({
            // set itemSelector so .grid-sizer is not used in layout
            filter: '*',
            selector: '.iso-item'
          });
          img_load_refresh($gridFit);

          // REFRESH DOPO CARICAMENTO IMMAGINI
          function img_load_refresh($arg){
            // layout Isotope after each image loads
            $arg.imagesLoaded().progress( function() {
              $arg.isotope('layout');
              $('.iso-list').css('height', 'auto');
            });
          }

          $('.iso-list').css('height', 'auto');

          // Ricalcolo le altezze dei filtri da ridurre
          FiltriContenuto.start();

        }
      });

		} // fine ubp_loadprojectdata()




    /* ---------------------------------------------------------
		Module: Cambia edizione
		Added:
		--------------------------------------------------------- */

		function ubp_change_edition(){
			$('#filtri-globali').append('<div id="edition-loader"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></di');
			ubp_loadprojectdata();
		}


    /* ---------------------------------------------------------
		Module: Update dei filtri progetto
		Added:
		--------------------------------------------------------- */

		function ubp_update_filters(filter_data){

      // NOT IN HOME
      if(!$('body').hasClass('home')){
        // aggiorna select titolo evento
        var titoloevento_items = '';
        for (var i=0;i<filter_data.titoloevento.length;i++){
          if (filter_data.titoloevento[i].slug !== '') {
            titoloevento_items += '<li class="pr-2 me-2" data-title="'+filter_data.titoloevento[i].name+'" data-filter=".sede-evento-'+filter_data.titoloevento[i].slug+'">'+filter_data.titoloevento[i].name+'</li>';
          }
        }
        $('#filters-titoloevento li:not(:last)').remove();
        $('#filters-titoloevento').prepend(titoloevento_items);
        // se non ci sono termini non mostro il filtro
        if(filter_data.titoloevento.length > 0){
          $('#filtri-titoloevento').removeClass('d-none');
        } else {
          $('#filtri-titoloevento').addClass('d-none');
        }
      }


      // aggiorna select temi
			var temi_items = '';
			for (var i=0;i<filter_data.temi.length;i++){
				if (filter_data.temi[i].slug !== '') {
					temi_items += '<li class="pr-2 me-2" data-title="'+filter_data.temi[i].name+'" data-filter=".temi-'+filter_data.temi[i].slug+'">'+filter_data.temi[i].name+'</li>';
				}
			}
			$('#filters-temi li:not(:last)').remove();
			$('#filters-temi').prepend(temi_items);
      // se non ci sono termini non mostro il filtro
      if(filter_data.temi.length > 0){
        $('#filtri-temi').removeClass('d-none');
      } else {
        $('#filtri-temi').addClass('d-none');
      }


      // aggiorna select parolechiave
      var parolechiave_items = '';
      for (var i=0;i<filter_data.parolechiave.length;i++){
        if (filter_data.parolechiave[i].slug !== '') {
          parolechiave_items += '<li class="pr-2 me-2" data-title="'+filter_data.parolechiave[i].name+'" data-filter=".parolechiave-'+filter_data.parolechiave[i].slug+'">'+filter_data.parolechiave[i].name+'</li>';
        }
      }
      $('#filters-parolechiave li:not(:last)').remove();
      $('#filters-parolechiave').prepend(parolechiave_items);
      // se non ci sono termini non mostro il filtro
      if(filter_data.parolechiave.length > 0){
        $('#filtri-parolechiave').removeClass('d-none');
      } else {
        $('#filtri-parolechiave').addClass('d-none');
      }


      // aggiorna select promotori
			var promotori_options = '';
			for (var i=0;i<filter_data.promotori.length;i++){
				if (filter_data.promotori[i].slug !== '') {
					promotori_options += '<li class="pr-2 me-2" value=".promotore-'+filter_data.promotori[i].slug+'">'+filter_data.promotori[i].name+'</li>';
				}
			}
			$('#promotori-select li:not(:last)').remove();
      $('#promotori-select').prepend(promotori_options);
      // se non ci sono termini non mostro il filtro
      if(filter_data.promotori.length > 0){
        $('#filtri-promotori').removeClass('d-none');
      } else {
        $('#filtri-promotori').addClass('d-none');
      }


      // aggiorna select luoghi
			var luoghi_options = '';
			for (var i=0;i<filter_data.luoghi.length;i++){
				if (filter_data.luoghi[i].slug !== '') {
					luoghi_options += '<li class="pr-2 me-2" value=".luogo-'+filter_data.luoghi[i].slug+'">'+filter_data.luoghi[i].name+'</li>';
				}
			}
			$('#luoghi-select li:not(:last)').remove();
			$('#luoghi-select').prepend(luoghi_options);
      // se non ci sono termini non mostro il filtro
      if(filter_data.luoghi.length > 0){
        $('#filtri-luoghi').removeClass('d-none');
      } else {
        $('#filtri-luoghi').addClass('d-none');
      }
		}



    /* ---------------------------------------------------------
		Module: eventi di cambio dei filtri
		Added:
		--------------------------------------------------------- */

    // filtro edizioni
		$('#edizioni-select').on('click', 'li', function(e){
      $('#edizioni-select li').removeClass('selected');
      $(this).toggleClass('selected');
			ubp_change_edition();
		});


    // filtro tipo di contenuto
    $('#switch-contenuti').on('click', 'a', function(e){
      $('#switch-contenuti a').removeClass('active');
      $(this).toggleClass('active');

      // GESTIONE MAIN TITLE
      // Stampo il titolo nel main title h2
      // se clicco su "tutti" ritorna "temi";
      if($(this).attr('id')=='tutti-select'){
        $('#filters-main-title').html($('#tile-temi span.h2').html());
      } else {
        $('#filters-main-title').html($(this).html());
      }


      $container = $('#iso');
      var contenutiSelector = $(this).attr('data-filter');
      $container.isotope({ filter: contenutiSelector	});
      $('.iso-list').isotope({ filter: contenutiSelector });

      // -----------------------------------
      // mostra su mappa
      if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).text();
        var selector_filter = $(this).attr('data-filter');

        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);

        if (selector_filter !== '' && selector_filter !== '*') {
          // search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts, function(e){
            return e.nome_promotore == selector_title;
          });
        }
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
        LayoutMappa.mappa(sel_projects_data);

      }
      return false;
    });


    // filtro promotori
		$('#promotori-select').on('click', 'li', function(e){
      $('#promotori-select li').removeClass('selected');
      $(this).toggleClass('selected');

			$container = $('#iso');
			var promotoriSelector = $(this).attr('value');
			$container.isotope({ filter: promotoriSelector	});
      $('.iso-list').isotope({ filter: promotoriSelector });

      // -----------------------------------
			// mostra su mappa
			if ($('#projects-map').hasClass('active')) {
				var selector_title = $(this).text();
				var selector_filter = $(this).attr('value');

				// clone projects_data object
				var sel_projects_data = jQuery.extend({}, projects_data);

				if (selector_filter !== '' && selector_filter !== '*') {
					// search for selected item in new object's post array
					sel_projects_data.posts = $.grep(projects_data.posts, function(e){
            return e.nome_promotore == selector_title;
	        });
				}
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
				LayoutMappa.mappa(sel_projects_data);

			}
			return false;
		});

		// filtro luoghi
		$('#luoghi-select').on('click', 'li', function(e){
      $('#luoghi-select li').removeClass('selected');
      $(this).toggleClass('selected');

			$container = $('#iso');
			var luoghi_selector = $(this).attr('value');

      console.log(luoghi_selector);

			$container.isotope({ filter: luoghi_selector });
      $('.iso-list').isotope({ filter: luoghi_selector });

      // -----------------------------------
			// mostra su mappa
			if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).text();
				var selector_filter = $(this).attr('value');

        // console.log('selector_title', selector_title);
        // console.log('selector_filter', selector_filter);

				// clone projects_data object
				var sel_projects_data = jQuery.extend({}, projects_data);

        // console.log('sel_projects_data', sel_projects_data);


				//console.log('selector_filter:',selector_filter);
				if (selector_filter !== '' && selector_filter !== '*') {
					// search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts , function(obj) {

            if(obj.locations){
              var part = obj.locations;

              // console.log('obj', obj);

              var inArray = false;
              for(var i=0;i<part.length;i++){
                if(part[i].city == selector_title){
                    return part[i].city;
                }
              }
            }

          });
				}
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
				LayoutMappa.mappa(sel_projects_data);
			}
			return false;
		});




    	  // filtro titoloevento
    		$('#filters-titoloevento').on('click', 'li', function(e){
    			e.preventDefault();
          $container = $('#iso');
    			var $this = $(this);
    			// don't proceed if already selected
    			if ( $this.hasClass('selected') ) {
    			  return false;
    			}
    			$('#filters-titoloevento').find('.selected').removeClass('selected');
    			$this.addClass('selected');

    			//When an item is clicked, sort the items.
    			var selector = $(this).attr('data-filter');
    			$container.isotope({ filter: selector });
          $('.iso-list').isotope({ filter: selector });

    			if ($('#projects-map').hasClass('active')) {
    				var selector_title = $(this).attr('data-title');
    				var selector_filter = $(this).attr('data-filter');
    				// clone projects_data object
    				var sel_projects_data = jQuery.extend({}, projects_data);
    				//console.log('selector_filter:',selector_filter);
    				if (selector_filter !== '') {
    					// search for selected item in new object's post array
    					sel_projects_data.posts = $.grep(projects_data.posts, function(e){
    	          if ($.inArray( selector_title, e.category_list ) != -1) {
    	              return e.category_list;
    	          }
    	        });
    				}
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
    				LayoutMappa.mappa(sel_projects_data);
    			}

    			return false;

    		});



	  // filtro temi
		$('#filters-temi').on('click', 'li', function(e){
			e.preventDefault();
      $container = $('#iso');
			var $this = $(this);
			// don't proceed if already selected
			if ( $this.hasClass('selected') ) {
			  return false;
			}
			$('#filters-temi').find('.selected').removeClass('selected');
			$this.addClass('selected');

			//When an item is clicked, sort the items.
			var selector = $(this).attr('data-filter');
			$container.isotope({ filter: selector });
      $('.iso-list').isotope({ filter: selector });

			if ($('#projects-map').hasClass('active')) {
				var selector_title = $(this).attr('data-title');
				var selector_filter = $(this).attr('data-filter');
				// clone projects_data object
				var sel_projects_data = jQuery.extend({}, projects_data);
				//console.log('selector_filter:',selector_filter);
				if (selector_filter !== '') {
					// search for selected item in new object's post array
					sel_projects_data.posts = $.grep(projects_data.posts, function(e){
	          if ($.inArray( selector_title, e.category_list ) != -1) {
	              return e.category_list;
	          }
	        });
				}
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
				LayoutMappa.mappa(sel_projects_data);
			}

			return false;

		});


    // filtro parolechiave
		$('#filters-parolechiave').on('click', 'li', function(e){
			e.preventDefault();
      $container = $('#iso');
			var $this = $(this);
			// don't proceed if already selected
			if ( $this.hasClass('selected') ) {
			  return false;
			}
			$('#filters-parolechiave').find('.selected').removeClass('selected');
			$this.addClass('selected');

			//When an item is clicked, sort the items.
			var selector = $(this).attr('data-filter');
			$container.isotope({ filter: selector });
      $('.iso-list').isotope({ filter: selector });

			if ($('#projects-map').hasClass('active')) {
				var selector_title = $(this).attr('data-title');
				var selector_filter = $(this).attr('data-filter');
				// clone projects_data object
				var sel_projects_data = jQuery.extend({}, projects_data);
				//console.log('selector_filter:',selector_filter);
				if (selector_filter !== '') {
					// search for selected item in new object's post array
					sel_projects_data.posts = $.grep(projects_data.posts, function(e){
	          if ($.inArray( selector_title, e.parolechiave_list ) != -1) {
	              return e.parolechiave_list;
	          }
	        });
				}
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
				LayoutMappa.mappa(sel_projects_data);
			}

			return false;

		});


    // togli
		// global search submit
		$('form#ubp-globalsearch-form .submit').on('click',function(e){
			e.preventDefault();
			$('form#ubp-globalsearch-form').submit();
		});



    /* ---------------------------------------------------------
    Module: generazione isotope e packery
    Added:
    --------------------------------------------------------- */

    var $container = $('#iso');
    if ($container.length) {
      $container.isotope({
        itemSelector : '.item',
        layoutMode : 'packery'
      });
    }
    // $('.iso-list').isotope();

    var container = document.querySelector('.packery');
    var pckry = null;
    var canvas = null;
    var ctx = null;
    if (container) {
      pckry = new Packery( container, {
        itemSelector: '.item',
        gutter: 0
      });

      // draw spaces on canvas
      canvas = container.querySelector('canvas');
      ctx = canvas ? canvas.getContext('2d') : null;
    }

    function drawSpaces() {
      // reset canvas size
    	canvas.width = pckry.size.width - 7; // altrimenti sborda a dx
      canvas.height = pckry.size.height;
      ctx.clearRect(0,0,canvas.width,canvas.height);
      // all Packery's empty spaces
      var spaces = pckry.packer.spaces;
      ctx.fillStyle = '#e9ecef';
      ctx.lineWidth = 14;

    	console.log(spaces);

      for ( var i=0, len = spaces.length; i<len; i++ ) {
        var space = spaces[i];
        var width = space.width;
        height = Math.min( space.height, canvas.height - space.y );

    		// non disegna l'ultimo spazio, che sborda dall'ultima tile
    		if( i == (len-1) ){
    			ctx.fillRect( 0, 0, 0, 0 );
    		} else{

    			var bigTile = $('#post-13283').width();

    			ctx.fillStyle = '#e9ecef';
    			ctx.fillRect( space.x + 7, space.y + 7, width - 14, height - 14 );

    			if( space.height > bigTile ){

    				ctx.fillStyle = '#ffffff';
    				var numeroSpazi = parseInt(space.height / bigTile);

    				// console.log(bigTile);
    				// console.log(numeroSpazi);

    				for ( var i=1, numeroSpazi; i<numeroSpazi; i++ ){
    					if(i == 1){
    						var spazio = -7;
    					} else {
    						var spazio = -7;
    					}
    					ctx.fillRect( space.x + 7, space.y + (spazio +(14 * i)) + ((bigTile + 0) * i), width - 14, 14 );
    					console.log('fire');
    				}

    			}

    		}

      }
    }

    // DISABILITO LA GENERAZIONE DI PACKERY PER AUMENTARE LE PRESTAZIONI
    // pckry.on( 'layoutComplete', drawSpaces );
    // //hack, trigger another layout for first rendering
    // pckry.layout();


    // DISABILITATO PERCHE MANDA IN CRASH TUTTO
    // LayoutMappa.mappa(projects_data, 'principale');
    // console.log(projects_data);

    /* ---------------------------------------------------------
    Module: toggle per la visualizzazione della mappa progetti
    Added:
    --------------------------------------------------------- */

    $('#switch-layout').on('click', 'a', function(e) {
    	e.preventDefault();
      elemento = $(this);

      if(elemento.attr('id') == 'maptoggle'){
        ubp_loadprojectdata();

        // verifica se i dati sono stati caricati dalla funzione ubp_loadprojectdata
        // dopo caricamento circa 246 viene aggiunta la classe init
        checkMapLoad();
        function checkMapLoad() {
          if($('#projects-map').hasClass('firstinit')){
            view_toggle(elemento);
          } else {
            setTimeout(checkMapLoad, 50); //wait 50 ms, then try again
            console.log('ricor');
          }
        }
      } else {
        view_toggle(elemento);
      }

    });

    function view_toggle(elem) {
      console.log('partito');
      // toggle delle classi active di griglia / mappa
      $('#switch-layout a').removeClass('active');
      $(elem).addClass('active');

      // ---------------------------------------
      // ------------------CLICK SU FILTRO MAPPA
      if($(elem).attr('id') == 'maptoggle'){

        var map_status = '1';
        $('#projects-map').attr('data-status', map_status);

        // ottieni il filtro attivo
        var active_filter = $('#subfiltri-globali').find('.active');
        var active_filter_id = $(active_filter).attr('id');

        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);

        switch (active_filter_id) {
          case 'filtri-titoloevento':
            var selector_title = $(active_filter).children('#filters-titoloevento li.selected').attr('data-title');
            var selector_filter = $(active_filter).children('#filters-titoloevento li.selected').attr('data-filter');

            if (selector_filter !== '' && selector_filter !== '*') {
              // search for selected item in new object's post array
              sel_projects_data.posts = $.grep(projects_data.posts, function(e){
                if ($.inArray( selector_title, e.category_list ) != -1) {
                  return e.category_list;
                }
              });
            }
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
            break;

          case 'filtri-temi':
            var selector_title = $(active_filter).children('#filters-temi li.selected').attr('data-title');
            var selector_filter = $(active_filter).children('#filters-temi li.selected').attr('data-filter');

            if (selector_filter !== '' && selector_filter !== '*') {
              // search for selected item in new object's post array
              sel_projects_data.posts = $.grep(projects_data.posts, function(e){
                if ($.inArray( selector_title, e.category_list ) != -1) {
                  return e.category_list;
                }
              });
            }
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
            break;

          case 'filtri-parolechiave':
            var selector_title = $(active_filter).children('#filters-parolechiave li.selected').attr('data-title');
            var selector_filter = $(active_filter).children('#filters-parolechiave li.selected').attr('data-filter');

            if (selector_filter !== '' && selector_filter !== '*') {
              // search for selected item in new object's post array
              sel_projects_data.posts = $.grep(projects_data.posts, function(e){
                if ($.inArray( selector_title, e.parolechiave_list ) != -1) {
                  return e.parolechiave_list;
                }
              });
            }
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
            break;

          case 'filtri-promotori':
            var selector_title = $(active_filter).children('#promotori-select li.selected').text();
            var selector_filter = $(active_filter).children('#promotori-select li.selected').val();

            if (selector_filter !== '' && selector_filter !== '*') {
              // search for selected item in new object's post array
              sel_projects_data.posts = $.grep(projects_data.posts, function(e){
                return e.nome_promotore == selector_title;
              });
            }
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
            break;

          case 'filtri-luoghi':
            var selector_title = $(active_filter).children('#luoghi-select li.selected').text();
            var selector_filter = $(active_filter).children('#luoghi-select li.selected').val();

            if (selector_filter !== '' && selector_filter !== '*') {
              // search for selected item in new object's post array
              sel_projects_data.posts = $.grep(projects_data.posts, function(e){
                return e.city == selector_title;
              });
            }
            var project_count = sel_projects_data.posts.length;
            sel_projects_data.count = project_count;
            break;
        }

        // resize map container according to window size
        LayoutMappa.mapResize();

        // initialize map if visible (delay for CSS animation)
        // if (!map) { ubp_map_init(); }
        // LayoutMappa.start();
        LayoutMappa.mapInit();

        // $(this).addClass('active');
        $('#projects-map').addClass('active');
        //$('#ubp_map_form').fadeIn();
        setTimeout(function() {
          LayoutMappa.mappa(sel_projects_data, 'settimeout');
          LayoutMappa.mapResize();
        }, 500);

        // nascondo griglia e lista
        $('#iso').hide();
        $('#content > #lista').hide();

      }


      // ---------------------------------------
      // ------------------CLICK SU FILTRO GRIGLIA
      if($(elem).attr('id') == 'gridtoggle'){
        // nascondo mappa e lista
        // $('#projects-map').removeClass('active');
        $('#projects-map').height(0);
        $('#content > #lista').hide();

        $container.show().isotope();
      }


      // ---------------------------------------
      // ------------------CLICK SU FILTRO LISTA
      if($(elem).attr('id') == 'listtoggle'){

        console.log( 'altezza prima' + $('.iso-list').css('height') );

        // nascondo mappa e griglia
        // $('#projects-map').removeClass('active');
        $('#projects-map').height(0);
        $container.hide();

        $('#content > #lista').show();
        // $('.iso-list').isotope({ filter: '*' });

        // $('.iso-list').on( 'layoutComplete', function( event ) {
        //   console.log( 'altezza dopo' + $('.iso-list').css('height') );
        //   $('.iso-list').css('height', 'auto');
        // });

        $('.iso-list').isotope().on( 'layoutComplete', function( event, filteredItems ) {
          // $('.iso-list').isotope({ filter: '*' });
          console.log( 'altezza dopo' + $('.iso-list').css('height') );
          $('.iso-list').css('min-height', $('.iso-list').css('height'));
        });
      }
    }


    /* ---------------------------------------------------------
    Module: Window resize functions
    Added:
    --------------------------------------------------------- */

    $(window).resize(function() {
    	var map_status = parseInt($('#projects-map').attr('data-status'));
    	if (map_status === 1) {
    		LayoutMappa.mapResize();
    		setTimeout(function() {
    			$('#projects-map').addClass('active');
    		}, 1000);
    	}
    });

    /* ^ END module homeScripts ----------------------------------------- */

  }



  return {
    homeScripts : homeScripts
  }


})();
